module.exports = __webpack_public_path__ + "img/gbwhatsapp-qr-code-chat.5be783de.webp";